<script setup>
import CounterNumberValue from "@shared/components/atoms/CounterNumberValue.vue"
import {useLoyaltyChestStore} from "@shared/stores/LoyaltyChestStore"

const loyaltyChestStore = useLoyaltyChestStore()
</script>

<template>
    <div :class="{
        show: loyaltyChestStore.loyaltyChest
    }">
        <div class="loyaltyBarComponent">
            <div class="divDiamondIcon"></div>
            <div class="divDiamondCount">{{ loyaltyChestStore.getDiamondsAmount(loyaltyChestStore.getTier) }}/10</div>
            <div class="divDiamondProgressContainer">
                <div
                    class="divDiamondProgress"
                    :style="{width: `${loyaltyChestStore.getProgress}%`}"
                />
                <div class="divDiamondProgressText">
                    <CounterNumberValue
                        :count="loyaltyChestStore.getProgress"
                        :decimal-places="2"
                    />
                </div>
            </div>
            <div class="divTreasureChest"></div>
            <div class="divAnimationContainer">
                <div class="divAnimationImage">
                    <div class="divAnimationDiamondCount"></div>
                </div>
                <div class="divAnimationFirework"></div>
                <div class="divAnimationFirework"></div>
                <div class="divAnimationFirework"></div>
            </div>
        </div>
    </div>
</template>
